var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21341 10.7615C9.9147 12.4628 9.9147 15.2218 8.21341 16.9231C6.51212 18.6244 3.75314 18.6244 2.05185 16.9231C0.350556 15.2218 0.350556 12.4628 2.05185 10.7615C3.75314 9.06025 6.51212 9.06025 8.21341 10.7615ZM9.00729 11.8993L18.6776 7.06412L9.00729 11.8993ZM9.00729 15.787L18.6776 20.6222L9.00729 15.787Z",
    fill: "#4F46E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21298 10.7618C9.91435 12.4631 9.91435 15.2215 8.21298 16.9229C6.51169 18.6242 3.75328 18.6242 2.05191 16.9229C0.350536 15.2215 0.350536 12.4631 2.05191 10.7618C3.75328 9.06047 6.51169 9.06047 8.21298 10.7618Z",
    stroke: "#4F46E5",
    strokeWidth: 1.55183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00684 11.8995L18.6772 7.0643",
    stroke: "#4F46E5",
    strokeWidth: 1.55183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00684 15.7869L18.6772 20.6221",
    stroke: "#4F46E5",
    strokeWidth: 1.55183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6392 19.4779C27.3405 21.1792 27.3405 23.9382 25.6392 25.6395C23.9379 27.3408 21.1789 27.3408 19.4776 25.6395C17.7763 23.9382 17.7763 21.1792 19.4776 19.4779C21.1789 17.7766 23.9379 17.7766 25.6392 19.4779Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6388 19.4781C27.3401 21.1795 27.3401 23.9378 25.6388 25.6391C23.9374 27.3405 21.179 27.3405 19.4776 25.6391C17.7763 23.9378 17.7763 21.1795 19.4776 19.4781C21.179 17.7769 23.9374 17.7769 25.6388 19.4781Z",
    stroke: "#4F46E5",
    strokeWidth: 1.55183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6392 2.05172C27.3405 3.75301 27.3405 6.512 25.6392 8.21329C23.9379 9.91458 21.1789 9.91458 19.4776 8.21329C17.7763 6.512 17.7763 3.75301 19.4776 2.05172C21.1789 0.350434 23.9379 0.350434 25.6392 2.05172Z",
    fill: "#4F46E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6388 2.05194C27.3401 3.75331 27.3401 6.51172 25.6388 8.21301C23.9374 9.91438 21.179 9.91438 19.4776 8.21301C17.7763 6.51172 17.7763 3.75331 19.4776 2.05194C21.179 0.350566 23.9374 0.350566 25.6388 2.05194Z",
    stroke: "#4F46E5",
    strokeWidth: 1.55183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.90c8014df1091c9a4cec411ac64109ce.svg";
export { ForwardRef as ReactComponent };